/** global jQuery */

import './modules/_skip-link-focus-fix'
import './modules/_foundation-scripts'

import { detect } from 'detect-browser'

/*************** Browser Version ***************/
const browser = detect()
const browser_version = browser.version.split('.')
const browser_html_class = browser.name + '-' + browser_version[0]
;(function ($) {
	/*************** Template part region toggle button ***************/
	$('#theme_debug_regions').on('click', function (event) {
		event.preventDefault()

		$('.placeHolderPosition').slideToggle()
	})

	$('html').addClass(browser_html_class)
})(jQuery)
